<div class="form-group mb-2">
  <label class="form-label fw-semibold">
    {{ label + " (Đã có " + countItems() + " mục)" }}
  </label>

  <textarea
    class="form-control"
    rows="5"
    [placeholder]="placeholder"
    [value]="textareaValue"
    (input)="onInput($event)"></textarea>
</div>